import { Chip } from "@mui/material";
import { useTranslation } from "react-i18next";
import { EquipmentResponse } from "../../../types/model/warehouse/equipment";

interface StatusChipProps {
  status?: EquipmentResponse["status"];
}

const STATUS_COLORS = {
  available: "success",
  unavailable: "warning",
  damaged: "error",
} as const;

export default function StatusChip({ status }: Readonly<StatusChipProps>) {
  const { t } = useTranslation();
  if (!status) return <>-</>;

  return (
    <Chip
      size="small"
      color={STATUS_COLORS[status]}
      label={t(`warehouse.equipment.statuses.${status}`)}
    />
  );
}